import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class player
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.player = {};

/**
 * GET Endpoint `/player/report/codes`
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.player
 */
ReachAPI.player.getReportCodes = function () {
    var url = ReachAPI.server + '/player/report/codes';
    var jqPromise = ReachAPI.getWithFallback(url, 'json');

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug('Retrieved Report Codes from the CACHE (API call failed)', null, __fileline);
        } else {
            Log.Debug('Retrieved Report Codes from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Report Codes',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/player/update/blacklist`
 * @param {string} uuid
 * @param {string} platform
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.player
 */
ReachAPI.player.getUpdateBlacklist = function (uuid, platform) {
    var url = ReachAPI.server + '/player/update/blacklist';
    var params = {
        uuid: uuid,
        platforms: platform,
    };
    var jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved Update Blacklist from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved Update Blacklist from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Update Blacklist',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * PUT Endpoint `/player/status/online`
 * @param {string} uuid
 * @param {string} player_version
 * @param {string} signage_version
 * @param {string} [remote_support_device_id]
 * @param {string} [lastRestart]
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.player
 */
ReachAPI.player.putStatusOnline = function (
    uuid,
    player_version,
    signage_version,
    remote_support_device_id,
    timeline_id,
    lastRestart
) {
    uuid = uuid || '';
    player_version = player_version || '';
    signage_version = signage_version || '';
    timeline_id = timeline_id || '';

    var url = ReachAPI.server + '/player/status/online';
    var params = {
        uuid: uuid,
        player_version: player_version,
        signage_version: signage_version,
        timeline_id: timeline_id,
    };

    if (remote_support_device_id) {
        params.remote_support_device_id = remote_support_device_id;
    }

    if (lastRestart) {
        params.last_restart = lastRestart;
    }

    return ReachAPI.put(url, params);
};

/**
 * PUT Endpoint `/player/capabilities`
 * @param {string} uuid
 * @param {string} capabilities
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.player
 */
ReachAPI.player.putPlatformCapabilities = function (uuid, capabilities) {
    uuid = uuid || '';
    capabilities = capabilities || '';

    var url = ReachAPI.server + '/player/capabilities';
    var params = {
        uuid: uuid,
        capabilities: capabilities,
    };

    return ReachAPI.put(url, params);
};

/**
 * GET Endpoint `/player/certificate`
 * @param uuid
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.player
 */
ReachAPI.player.getPlayerCertificate = function (uuid) {
    var url = ReachAPI.server + '/player/certificate/' + uuid;
    var jqPromise = ReachAPI.get(url, 'json');

    jqPromise.done(function () {
        Log.Info('Retrieved Player Certificate from the API', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Player Certificate',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * GET Endpoint `/player/exacqvision/servers`
 * @param {string} uuid
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.player
 */
ReachAPI.player.getExacqVisionServers = function (uuid) {
    var url = ReachAPI.server + '/player/exacqvision/servers';
    var params = {
        player_uuid: uuid,
    };
    var jqPromise = ReachAPI.getWithFallback(url, 'json', params);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved ExacqVision Servers from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved ExacqVision Servers from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve Exacqvision Servers',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};

/**
 * POST Endpoint `/player/report`
 * @param {string} uuid
 * @param {array} items
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.player
 */
ReachAPI.player.postReport = function (uuid, items) {
    var url = ReachAPI.server + '/player/report/' + uuid;
    var settings;
    var jqPromise;

    items.forEach(function (value, index) {
        if (typeof items[index].data !== 'string') {
            items[index].data = JSON.stringify(items[index].data);
        }
    });

    settings = {
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify({
            source: 'reach-signage-player',
            items: items,
        }),
    };

    jqPromise = ReachAPI.ajax('POST', url, settings);

    jqPromise.done(function () {
        Log.Info('Report Sent', null, __fileline);
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown) {
        Log.Warning(
            'Failed to send Report',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, null, null)
        );
    });

    return jqPromise;
};

/**
 * POST Endpoint '/player/detail'
 * @param {string} uuid
 * @param {object} systemData
 * @param {object} [systemData.HardwareInfo]
 * @param {string} [systemData.HardwareInfo.Manufacturer]
 * @param {string} [systemData.HardwareInfo.Model]
 * @param {number} [systemData.HardwareInfo.NumberOfLogicalProcessors]
 * @param {number} [systemData.HardwareInfo.NumberOfProcessors]
 * @param {number} [systemData.HardwareInfo.TotalPhysicalMemory]
 * @param {object[]} [systemData.HardwareInfo.GraphicProcessors] Graphics
 * processors not currently used
 * @param {string} [systemData.HardwareInfo.GraphicProcessors[].Name]
 * @param {number} [systemData.HardwareInfo.GraphicProcessors[].Memory]
 * @param {string} [systemData.HardwareInfo.GraphicProcessors[].DriverVersion]
 * @param {object} [systemData.OperatingSystemInfo]
 * @param {string} [systemData.OperatingSystemInfo.Name]
 * @param {string} [systemData.OperatingSystemInfo.Manufacturer]
 * @param {('32-bit'|'64-bit')} [systemData.OperatingSystemInfo.Architecture]
 * @param {string} [systemData.OperatingSystemInfo.Version]
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.player
 */
ReachAPI.player.postReportSystemConfig = function (uuid, systemData) {
    var url = ReachAPI.server + '/player/detail/' + uuid;
    var params = {
        manufacturer: systemData.HardwareInfo.Manufacturer,
        model: systemData.HardwareInfo.Model,
        number_logical_processors: systemData.HardwareInfo.NumberOfLogicalProcessors,
        number_processors: systemData.HardwareInfo.NumberOfProcessors,
        physical_memory: systemData.HardwareInfo.TotalPhysicalMemory,
        os_name: systemData.OperatingSystemInfo.Name,
        os_version: systemData.OperatingSystemInfo.Version,
        os_architecture: systemData.OperatingSystemInfo.Architecture,
    };

    return ReachAPI.post(url, params);
};

/**
 * PUT Endpoint `/player/metrics/time_slippage`
 * @param {string} uuid
 * @param {number} stdev
 * @param {number} max
 * @param {number} avg
 * @param {number} max_delta
 * @returns {jQuery.jqXHR}
 * @memberof ReachAPI.player
 */
ReachAPI.player.putMetricsTimeSlippage = function (uuid, stdev, max, avg, maxDelta) {
    var url = ReachAPI.server + '/player/metrics/time_slippage';
    var params = {
        uuid: uuid,
        TimeSlippageStdev: stdev,
        TimeSlippageMaximum: max,
        TimeSlippageAverage: avg,
        TimeSlippageMaxDelta: maxDelta,
    };

    return ReachAPI.put(url, params);
};
